import React, { useState } from "react";
import "./BookingForm.css";

export default function BookingForm() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  const [status, setStatus] = useState("");

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("Submitting…");

    const message = `
🧺 *New Berkinson Pickup Booking*

👤 *Name:* ${form.name}
📧 *Email:* ${form.email}
📞 *Phone:* ${form.phone}
🏠 *Address:* ${form.address}
`;

    const BOT_TOKEN = "7789187036:AAHaZi8-FlCp1HDKC9g8fOAvSlVRi5_r5hM";
    const CHAT_ID = "1128378813";

    try {
      const res = await fetch(
        `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            chat_id: CHAT_ID,
            text: message,
            parse_mode: "Markdown",
          }),
        }
      );

      if (res.ok) {
        setStatus("✅ Booking sent successfully!");
        setForm({ name: "", email: "", phone: "", address: "" });
      } else {
        setStatus("❌ Failed to send booking.");
      }
    } catch (error) {
      console.error(error);
      setStatus("❌ Network error. Please try again.");
    }
  }

  return (
    <div className="premium-form-wrapper">
      <form className="premium-booking-form" onSubmit={handleSubmit}>
        <input
          required
          name="name"
          value={form.name}
          placeholder="Full Name"
          onChange={handleChange}
        />
        <input
          required
          type="email"
          name="email"
          value={form.email}
          placeholder="Email"
          onChange={handleChange}
        />
        <input
          required
          name="phone"
          value={form.phone}
          placeholder="Phone Number"
          onChange={handleChange}
        />
        <input
          required
          name="address"
          value={form.address}
          placeholder="Residential Address"
          onChange={handleChange}
        />
        <button type="submit">📦 Book Pickup</button>
      </form>

      {status && <p className="form-status">{status}</p>}
    </div>
  );
}
